/**
 * Store defines all modules automatically via autoloader
 * Place common vuex store in the @/modules/core dir
 */

import Vue from 'vue'
import Vuex from 'vuex'
import autoload from '@/utils/autoloader'

const data_context = require.context('./data', true, /(\w|\/)*(.json)$/)

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...autoload(data_context)
  }
})
